import { render, staticRenderFns } from "./abstract_consultation.vue?vue&type=template&id=6c675668&"
import script from "./abstract_consultation.vue?vue&type=script&lang=js&"
export * from "./abstract_consultation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports